import { Feature } from "../components/sections/features/feature";

export const FEATURES: Feature[] = [
    {
        title: "Built for Sales & Marketing Teams", icon: "bi-award-fill", details: [
            "BunnyCRM is purpose-built automation for sales and marketing, not a generic tool stretched to fit.",
            "We stay close to how sales and marketing teams actually work, and ship features that match."
        ]
    },
    {
        title: "Fast Onboarding", icon: "bi-sliders", details: [
            "Get your pipelines, workflows, and campaigns running in days, not months.",
            "No lengthy custom builds — just configure and go."
        ]
    },
    {
        title: "Reliable at Scale", icon: "bi-patch-check-fill", details: [
            "Built on infrastructure tested for reliability, with a 99.9% uptime guarantee.",
            "Your pipelines and campaigns keep running, whether you have ten leads or ten thousand."
        ]
    },
    {
        title: "Clear ROI & Reporting", icon: "bi-people-fill", details: [
            "Unified dashboards tie every lead, campaign, and deal back to revenue.",
            "Know what's working without stitching together spreadsheets."
        ]
    },
    {
        title: "All-in-One Platform", icon: "bi-diagram-3-fill", details: [
            "Sales automation, marketing automation, and analytics — in one platform instead of three disconnected tools.",
            "One record per contact, shared across your whole team."
        ]
    },
    {
        title: "Modern, Scalable Technology", icon: "bi-cpu-fill", details: [
            "Built on cloud infrastructure that grows with your business.",
            "Regular updates ship automatically — no upgrade projects required."
        ]
    },
    {
        title: "Straightforward Pricing", icon: "bi-tag-fill", details: [
            "Predictable subscription pricing — no scoping calls, no hidden project costs."
        ]
    },
    {
        title: "Proven Track Record", icon: "bi-graph-up-arrow", details: [
            "Trusted by growing businesses across sales and marketing teams who rely on BunnyCRM every day."
        ]
    },
    {
        title: "Commitment to Security", icon: "bi-shield-lock-fill", details: [
            "We prioritize data protection and implement robust security measures to safeguard your sensitive information."
        ]
    },
    {
        title: "Ongoing Support", icon: "bi-headset", details: [
            "Support is included with every subscription — not a separate contract or a support ticket queue."
        ]
    },
];
